/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Attendee_OrganizerInputs */



/**
* | output |
* | --- |
* | "Organiser" |
*
* @param {Meeting_Attendee_OrganizerInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_attendee_organizer = /** @type {((inputs?: Meeting_Attendee_OrganizerInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Attendee_OrganizerInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Organisator")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Organisateur")
	return /** @type {LocalizedString} */ ("Organiser")
});